import { useCallback } from 'react';
import { useState, Fragment, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CreateVideoModal from "../AiModule/CreateVideoModal";
import { Menu, Dialog, Transition } from "@headlessui/react";
import axios from "axios";
import { toastify } from "../../components/Toast";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as MySVG } from "../../assets/icons/7601886_top_arrow-update.svg";
import ScrollToTop from "react-scroll-to-top";
import { UrlConverter } from "../../utils/UrlConverter";
import CreateCampaignModal from "../EmailAutomation/CreateCampaign";
import { Search, ChevronDown, LinkIcon, Play, MoreVertical, Trash2 } from "lucide-react";
import Masonry from "react-masonry-css";
import services from "../../API";
import { CircularLoader } from "../Loader/CircularLoader";
import { useDispatch } from "react-redux";
import { openCreateVideoModal } from "../../Store/uiSlice";
import AdVideoPlayer, { isVideoAd } from "./AdVideoPlayer";

const breakpointColumns = {
  default: 5,
  1536: 4,
  1200: 3,
  900: 2,
  640: 1,
};
const AdsList = () => {
  const brandIdRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("my-content");
  const [selectedAds, setSelectedAds] = useState([]);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const dispatch = useDispatch();

  const [isEditingBrand, setIsEditingBrand] = useState(false);
  const [isAnalyzingBrand, setIsAnalyzingBrand] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [editedBrand, setEditedBrand] = useState(selectedBrand);
  const [adsList, setAdsList] = useState([]);
  const [contentSearch, setContentSearch] = useState("");
  const [updateAds, setUpdateAds] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [brands, setBrands] = useState([]);
  const [selectedBrandName, setSelectedBrandName] = useState("");
  const [selectedBrandId, setSelectedBrandId] = useState(
    localStorage.getItem("selectedBrandId") || ""
  );
  let [isOpensDelete, setIsOpenDelete] = useState(false);

  const [showBrandDropdown, setShowBrandDropdown] = useState(false);
  const [brandSearchTerm, setBrandSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [referenceCard, setReferenceCard] = useState("");
  const [referenceCardId, setReferenceId] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [expandedAds, setExpandedAds] = useState([]);
  const [sortBy, setSortBy] = useState("newest-first");
  const [selected, ] = useState("video");
  const [videoLoaded, setVideoLoaded] = useState({});
  const [videoBuffering, setVideoBuffering] = useState({});
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const [adToDelete, setAdToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isVideoPaused, setIsVideoPaused] = useState(false);
  const [isSeeking, setIsSeeking] = useState({});
  const [isMuted, ] = useState(false);
  const videoRefs = useRef({});
  const playingVideoIdRef = useRef(null);
  const [isIOS] = useState(() => /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
  const registerPreviewVideo = useCallback((id, element) => {
    if (element) videoRefs.current[id] = element;
    else delete videoRefs.current[id];
  }, []);
  const startPreviewVideo = useCallback((id) => {
    const previousId = playingVideoIdRef.current;
    const previous = videoRefs.current[previousId];
    if (previousId !== id && previous) (previous.master || previous).pause();
    playingVideoIdRef.current = id;
    setPlayingVideoId(id);
    setIsVideoPaused(false);
  }, []);
  const pausePreviewVideo = useCallback((id) => {
    if (playingVideoIdRef.current === id) setIsVideoPaused(true);
  }, []);

  useEffect(() => {
    playingVideoIdRef.current = playingVideoId;
  }, [playingVideoId]);





  const sortLabels = {
    "newest-first": "Newest First",
    "oldest-first": "Oldest First",
    "recent-activity": "Recent Activity",
  };

  const options = [
    { value: "newest-first", label: "Newest First" },
    { value: "oldest-first", label: "Oldest First" },
    { value: "recent-activity", label: "Recent Activity" },
  ];

  const toggleExpand = (adId) => {
    setExpandedAds((prev) =>
      prev.includes(adId) ? prev.filter((id) => id !== adId) : [...prev, adId]
    );
  };
  const [, setAppTheme] = useState("");

  // const [brands, setBrands] = useState([]);
  const [inProcessAds, setInProcessAds] = useState(0);
  const [inProcessAdWithReference, setInProcessAdWithReference] =
    useState(false);

  const [contentTypes, ] = useState([
    {
      id: "video",
      name: "Video Ads",
      // count: 0,
      icon: `
 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-4 h-4">
  <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z"></path>
  <path d="m6.2 5.3 3.1 3.9"></path>
  <path d="m12.4 3.4 3.1 4"></path>
  <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"></path>
</svg>
      `,
    },
    {
      id: "ads",
      name: "Image Ads",
      // count: 10,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-megaphone w-4 h-4"><path d="m3 11 18-5v12L3 14v-3z"></path><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path></svg>',
    },

    // {
    //   id: "stacked-ads",
    //   name: "Stacked Ads",
    //   count: 5,
    //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layers w-4 h-4"><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"></path><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"></path><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"></path></svg>',
    // },
    // {
    //   id: "social",
    //   name: "Social Media",
    //   count: 7,
    //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2 w-4 h-4"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg>',
    // },
    // {
    //   id: "emails",
    //   name: "Emails",
    //   count: 3,
    //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mail w-4 h-4"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>',
    // },
    // {
    //   id: "landing",
    //   name: "Landing Pages",
    //   count: 2,
    //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-4 h-4"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>',
    // },
    // {
    //   id: "blog",
    //   name: "Blog",
    //   count: 4,
    //   icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-4 h-4"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>',
    // },
    {
      id: "automation",
      name: "Autopilot",
      // count: 10,
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock w-4 h-4"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>',
    },
    {
      id: "aicmo",
      name: "AI CMO",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles w-4 h-4"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"></path><path d="M5 3v4"></path><path d="M19 17v4"></path><path d="M3 5h4"></path><path d="M17 19h4"></path></svg>',
    },
  ]);
  const [selectedContentFilter, setSelectedContentFilter] = useState(() => {
    return location.state?.tab || localStorage.getItem("adsListActiveFilter") || contentTypes[0]?.id;
  });

  useEffect(() => {
    if (selectedContentFilter) {
      localStorage.setItem("adsListActiveFilter", selectedContentFilter);
    }
  }, [selectedContentFilter]);

  useEffect(() => {
    const handleStorageChange = () => {
      const theme = localStorage.getItem("theme");
      setAppTheme(theme);
    };

    window.addEventListener("storage", handleStorageChange);

    // Force a re-render when localStorage changes
    setAppTheme(localStorage.getItem("theme"));

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (location.state?.tab) {
      setSelectedContentFilter(location.state.tab);
      if (location.state.brandId) {
        const newBrandId = location.state.brandId;
        setSelectedBrandId(newBrandId);
        localStorage.setItem("selectedBrandId", newBrandId);

        // Sync the full brand object and name so the dropdown reflects the
        // newly selected brand immediately (without requiring a page refresh).
        const matchedBrand = brands.find((b) => b._id === newBrandId);
        if (matchedBrand) {
          setSelectedBrandName(matchedBrand.brandName || matchedBrand.internalName || "");
          setSelectedBrand({
            _id: matchedBrand._id,
            name: matchedBrand.brandName || "",
            internalName: matchedBrand.internalName || matchedBrand.brandName || "",
            description: matchedBrand.description || "",
            industry: matchedBrand.industry || "",
            colors: matchedBrand.brandColors || [],
            tone: matchedBrand.brandToneAndVoice || "",
            website: matchedBrand.url || "",
            targetMarket: matchedBrand.targetMarket || "",
            uniqueValue: matchedBrand.uniqueValue || "",
            mainJob: matchedBrand.mainJobOfProduct || "",
            differentiation: matchedBrand.differentiation || "",
            howItHelps: matchedBrand.howItHelps || "",
            features: matchedBrand.features || "",
            benefits: matchedBrand.benefits || "",
          });
        }
      }
      setUpdateAds((prev) => !prev);
      // Clean up state
      window.history.replaceState({}, document.title);
    }
  }, [location.state, brands]);

  // Filter brands based on search term
  const filteredBrands = brands.filter(
    (brand) =>
      brand.internalName
        ?.toLowerCase()
        .includes(brandSearchTerm?.toLowerCase()) ||
      brand.brandName
        ?.toLowerCase()
        .includes(brandSearchTerm?.toLowerCase()) ||
      brand?.description
        ?.toLowerCase()
        ?.includes(brandSearchTerm?.toLowerCase()) ||
      brand?.industry?.toLowerCase()?.includes(brandSearchTerm?.toLowerCase())
  );

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowBrandDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const brandId = urlSearchParams.get("brandId");
    const createdBrandName = urlSearchParams.get("brandName");
    const referenceId = urlSearchParams.get("referenceId");
    const fetchBrands = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}brands`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBrands(response.data.data);

        let brand;
        if (brandId) {
          brand = response.data.data.find((b) => b._id === brandId);
        } else {
          brand = response.data.data.find((b) => b._id === localStorage.getItem("selectedBrandId"));
        }

        // fallback to 0 index if no match found
        if (!brand && response.data.data.length > 0) {
          brand = response.data.data[0];
          localStorage.setItem("selectedBrandId", response.data.data[0]._id);
          setSelectedBrandId(response.data.data[0]._id);
        }

        // if (brand) {
        if (!brand) return;
        let brandDetail = {
          _id: brand._id || "",
          name: brand.brandName || "",
          internalName: brand.internalName || brand.brandName || "",
          description: brand.description || "",
          industry: brand.industry || "",
          colors: brand.brandColors || [],
          tone: brand.brandToneAndVoice || "",
          website: brand.url || "",
          targetMarket: brand.targetMarket || "",
          uniqueValue: brand?.uniqueValue || "",
          mainJob: brand.mainJobOfProduct || "",
          differentiation: brand.differentiation || "",
          howItHelps: brand.howItHelps || "",
          features: brand?.features || "",
          benefits: brand.benefits || "",
        };

        if (brandId) {
          setSelectedBrandId(brandId);
          setSelectedBrandName(createdBrandName);
          setSelectedBrand(brandDetail);
          setEditedBrand(brandDetail);
          setShowGenerateModal(true);
          return;
        }

        // }

        setSelectedBrand(brandDetail);
        setEditedBrand(brandDetail);
        if (response.data.data.length > 0) {
          setSelectedBrandName(response.data.data[0].brandName);
        }
      } catch (err) {
        console.error(err, "err");
        // setBrands([]);
      }
    };
    fetchBrands();
    // const brandId = urlSearchParams.get("brandId");
    // const createdBrandName = urlSearchParams.get("brandName");
    // if (brandId) {
    //   setSelectedBrandId(brandId);
    //   setSelectedBrandName(createdBrandName);
    //   setSelectedBrand({ _id: brandId, name: createdBrandName });
    //   setShowGenerateModal(true);
    // }
    const fetchData = async () => {
      setReferenceId(referenceId);
      await axios
        .get(`${process.env.REACT_APP_API}cards/single-card/${referenceId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(function (response) {

          setReferenceCard(response.data.data);
          if (referenceId) {
            setShowGenerateModal(true);
            setReferenceId(referenceId);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    };
    if (referenceId) {
      fetchData();
    }
  }, []);

  const checkGeneratingAdsStatus = useCallback(async (brandId) => {
    if (!brandId) return 0;
    const token = localStorage.getItem("token");
    try {
      const typeParam = selectedContentFilter === "aicmo"
        ? "AICMO"
        : selectedContentFilter?.charAt(0)?.toUpperCase() + selectedContentFilter?.slice(1);
      const AIResponse = await axios.get(
        `${process.env.REACT_APP_API}ads/in-progress?brandId=${brandId}&type=${typeParam}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );

      const inProgressAds = AIResponse.data.data.ads;
      if (inProgressAds && Array.isArray(inProgressAds)) {
        // Filter locally to prevent cross-tab bleed if backend ignores type
        const filtered = inProgressAds.filter(ad => {
          const t = ad.type || "";
          const iType = ad.internalAdType || "";
          const isAicmo = Boolean(ad.cmoId || ad.aiCmoId || t === "AICMO");

          if (selectedContentFilter === "aicmo") return isAicmo;

          // Prevent AI CMO ads from bleeding into normal Video/Image tabs
          if (isAicmo) return false;

          if (selectedContentFilter === "video") {
            const tLower = t.toLowerCase();
            const iTypeLower = iType.toLowerCase();
            const adTypeLower = (ad.adType || "").toLowerCase();
            return (
              tLower.includes("video") ||
              iTypeLower.includes("video") ||
              tLower.includes("talking") ||
              adTypeLower.includes("talking") ||
              tLower.includes("speaking") ||
              adTypeLower.includes("speaking")
            );
          }
          if (selectedContentFilter === "ads") return t === "Ads" || t === "image" || iType === "image";

          // For any other filter (like "automation"/Autopilot), do a strict match to prevent bleeding
          const filterLower = selectedContentFilter.toLowerCase();
          return t.toLowerCase() === filterLower || iType.toLowerCase() === filterLower;
        });
        return filtered.length;
      }
      return AIResponse.data.data.count;
    } catch (error) {
      console.error(error);
      return 0;
    }
  }, [selectedContentFilter]);

  const checkStatus = useCallback(async () => {
    const brandId = brandIdRef.current;
    if (!brandId) {
      setInProcessAds(0);
      return;
    }
    const count = await checkGeneratingAdsStatus(brandId);
    setInProcessAds(count);
  }, [checkGeneratingAdsStatus]);

  useEffect(() => {
    if (selectedContentFilter) {
      checkStatus();
    }
  }, [checkStatus, selectedContentFilter]);

  // Reset selection when filter, brand, format or tab changes
  useEffect(() => {
    setSelectedAds([]);
    setPlayingVideoId(null);
    setIsVideoPaused(false);
    setIsSeeking({});
    setAdsList([]); // Clear stale ads immediately so they don't flash on tab switch
  }, [selectedContentFilter, selectedBrandId, selected, activeTab]);

  const fetchAds = useCallback(async () => {
    const token = localStorage.getItem("token");
    const brandId = brandIdRef.current;
    if (!brandId) {
      setIsLoading(false);
      setLoading(false);
      return;
    }

    // Don't clear ads list immediately to prevent empty flash
    // setAdsList([]); 

    setLoading(true);
    setError("");
    // setVideoLoaded({}); // Reset video loading states only when new data arrives

    try {
      const filter = selectedContentFilter === "aicmo"
        ? "AICMO"
        : selectedContentFilter?.charAt(0)?.toUpperCase() + selectedContentFilter?.slice(1);

      const response = await axios.get(
        `${process.env.REACT_APP_API}ads/list?brandId=${brandId}&type=${filter}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );

      // setIsLoading(false); // Handled in finally
      const rawAds = response?.data?.data?.ads || [];
      if (playingVideoIdRef.current) {
        // A video is currently playing — apply the new list immediately
        // but preserve the loaded/buffering state of the active video
        // so its playback is not disrupted.
        setAdsList(rawAds);
        setVideoLoaded((prev) => {
          const preserved = {};
          const currentId = playingVideoIdRef.current;
          Object.keys(prev).forEach((key) => {
            if (key === currentId || key.startsWith(`${currentId}-`)) {
              preserved[key] = prev[key];
            }
          });
          return preserved;
        });
      } else {
        setAdsList(rawAds);
        setVideoLoaded({}); // Reset video states now that we have new videos
      }
    } catch (err) {
      console.error(err);
      // setIsLoading(false);
      setError("Failed to load brands. Please try again.");
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  }, [selectedContentFilter]);

  useEffect(() => {
    fetchAds();
  }, [selectedBrandId, selectedBrand, selectedContentFilter, updateAds, fetchAds]);

  // Fallback: if talking-head video layers haven't loaded within 5s, force-mark them ready
  // This handles browsers that suppress onLoadedData (mobile power-saving, CORS, etc.)
  useEffect(() => {
    if (!adsList.length) return;
    const talkingHeadAds = adsList.filter(ad => ad.adType === 'talking_head');
    if (!talkingHeadAds.length) return;

    const timer = setTimeout(() => {
      setVideoLoaded(prev => {
        const updates = {};
        talkingHeadAds.forEach(ad => {
          if (!prev[`${ad._id}-bg`]) updates[`${ad._id}-bg`] = true;
          if (!prev[`${ad._id}-overlay`]) updates[`${ad._id}-overlay`] = true;
        });
        return Object.keys(updates).length > 0 ? { ...prev, ...updates } : prev;
      });
    }, 5000);

    return () => clearTimeout(timer);
  }, [adsList]);

  brandIdRef.current = selectedBrandId || selectedBrand?._id;

  useEffect(() => {
    const check = async () => {
      const brandId = selectedBrandId || brandIdRef.current;
      if (!brandId) return;
      const count = await checkGeneratingAdsStatus(brandId);
      setInProcessAds(count);
    };
    check();
  }, [updateAds, showGenerateModal, inProcessAdWithReference, selectedBrandId, checkGeneratingAdsStatus]);

  useEffect(() => {
    let interval;
    // Only poll if there are actually ads in process
    if (inProcessAds > 0) {
      const pollingInterval = 60000;

      interval = setInterval(async () => {
        try {
          const brandId = brandIdRef.current;
          if (!brandId) {
            setInProcessAds(0);
            clearInterval(interval);
            return;
          }
          // Double check status
          const count = await checkGeneratingAdsStatus(brandId);

          // Update the count state
          setInProcessAds(count);

          // If any processing finished (e.g. from 2 down to 1)
          if (count < inProcessAds) {
            await fetchAds();
          }

          // If processing completely finished (count went to 0)
          if (count === 0) {
            clearInterval(interval);
            if (selectedContentFilter === "video" || selectedContentFilter === "talking-head" || selectedContentFilter === "speaking-character") {
              toastify("success", "Your videos are ready");
            } else {
              toastify("success", "Your images are ready");
            }
          }
        } catch (err) {
          console.error("Error checking generating ads:", err);
        }
      }, pollingInterval);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [inProcessAds, selectedContentFilter, selectedBrandId, checkGeneratingAdsStatus, fetchAds]);

  function closeModalDelete() {
    setIsOpenDelete(false);
    setAdToDelete(null);
  }

  const handleDeleteAdClick = (e, ad) => {
    e.stopPropagation();
    setAdToDelete(ad);
    setSelectedAds([]); // Clear selection when deleting a single one
    setIsOpenDelete(true);
  };

  const handleDeleteSelected = async () => {
    const adIdsToDelete = adToDelete ? [adToDelete._id] : selectedAds;
    if (adIdsToDelete.length === 0) return;


    setIsDeleting(true);
    try {
      const videoIds = [];
      const imageIds = [];

      adIdsToDelete.forEach(id => {
        // Find the ad object to determine its type
        const ad = (adToDelete && adToDelete._id === id)
          ? adToDelete
          : adsList.find(a => a._id === id);

        if (ad) {
          // Identify if it's a video ad
          const isVideo = ad.internalAdType === "video" ||
            ad.adType === "speaking_character" ||
            ad.adType === "talking_head" ||
            ad.type === "video";

          if (isVideo) {
            videoIds.push(id);
          } else {
            imageIds.push(id);
          }
        } else {
          // Fallback based on active tab or default
          if (selectedContentFilter === "video") {
            videoIds.push(id);
          } else {
            imageIds.push(id);
          }
        }
      });

      const deletePromises = [];
      if (videoIds.length > 0) {
        deletePromises.push(services.deleteMultipleVideoAds(videoIds));
      }
      if (imageIds.length > 0) {
        deletePromises.push(services.deleteMultipleAds(imageIds));
      }

      if (deletePromises.length > 0) {
        await Promise.all(deletePromises);
      }

      closeModalDelete();
      // Optimistic update for instant refresh
      setAdsList(prev => prev.filter(ad => !adIdsToDelete.includes(ad._id)));
      setUpdateAds(!updateAds);
      setSelectedAds([]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCreateContent = () => {
    if (selectedContentFilter === "aicmo") {
      navigate("/app/marketing");
    } else if (selectedContentFilter === "video" || selectedContentFilter === "ads") {
      dispatch(openCreateVideoModal({
        type: selectedContentFilter === "video" ? "videos" : "image-ads",
        brandId: selectedBrandId
      }));
    } else {
      setShowGenerateModal(true);
    }
  };

  const handleGenerateClick = (contentType) => {
    if (contentType === "aicmo") {
      navigate("/app/marketing");
    } else if (contentType === "video" || contentType === "ads") {
      dispatch(openCreateVideoModal({
        type: contentType === "video" ? "videos" : "image-ads",
        brandId: selectedBrandId
      }));
    } else {
      setShowGenerateModal(true);
    }
  };

  const handleCreateBrand = () => {
    navigate("/app/brands/new");
  };

  const handleBrandSelect = async (brand) => {
    localStorage.setItem("selectedBrandId", brand);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}brands/${brand}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      setIsLoading(false);
      // setBrands(response.data.data);
      setSelectedBrandName(response.data.data.brandName);
      setSelectedBrandId(response.data.data._id);
      const brandDetail = {
        _id: response.data.data._id,
        name: response.data.data.brandName,
        internalName: response.data.data.internalName || response.data.data.brandName,
        description: response.data.data.description,
        industry: response.data.data.industry,
        colors: response.data.data.brandColors,
        tone: response.data.data.brandToneAndVoice,
        website: response.data.data.url,
        targetMarket: response.data.data.targetMarket,
        uniqueValue:
          "AI-powered automation that learns from your team's workflow",
        mainJob: response.data.data.mainJobOfProduct,
        differentiation: response.data.data.differentiation,
        howItHelps: response.data.data.howItHelps,
        features: response.data.data.features,
        benefits: response.data.data.benefits,
      };
      setSelectedBrand(brandDetail);
      setEditedBrand(brandDetail);
      setShowBrandDropdown(false);
      setBrandSearchTerm("");
    } catch (err) {
      setError("Failed to load brands. Please try again.");
      setShowBrandDropdown(false);
      setBrandSearchTerm("");
      // setIsLoading(false);
    } finally {
      // setIsLoading(false);
      setLoading(false);
      setShowBrandDropdown(false);
      setBrandSearchTerm("");
    }
    // setSelectedBrand(brand);
    // setEditedBrand(brand);
    // setShowBrandDropdown(false);
    // setBrandSearchTerm("");
  };



  const handleContentGenerated = (contentType, count) => {

    // Handle the generated content here
  };

  // Brand editing functions
  const handleBrandEdit = () => {
    setIsEditingBrand(true);
    setEditedBrand(selectedBrand);
  };

  const handleBrandSave = async () => {
    const token = localStorage.getItem("token");
    // Map editedBrand to API payload
    const payload = {
      websiteUrl: UrlConverter(editedBrand.website),
      brandName: editedBrand.name,
      industry: editedBrand.industry,
      description: editedBrand.description,
      brandColor: editedBrand.colors[0] || "",
      brandColors: editedBrand.colors,
      logo: {
        src: "", // Add logo upload logic if needed
        alt: "main logo",
        width: 0,
        height: 0,
      },
      logos: [], // Add multiple logo upload logic if needed
      mainJobOfProduct: editedBrand.mainJob,
      howItHelps: editedBrand.howItHelps,
      differentiation: editedBrand.differentiation,
      benefits: editedBrand.benefits,
      features: editedBrand.features
        ? Array.isArray(editedBrand.features)
          ? editedBrand.features.map((f) => f.trim()).filter(Boolean) // already array
          : editedBrand.features
            .toString()
            .split("\n")
            .map((f) => f.trim())
            .filter(Boolean) // convert string to array
        : [],
      targetMarket: editedBrand.targetMarket,
      brandToneAndVoice: editedBrand.tone,
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}brands/${selectedBrand._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSelectedBrand(editedBrand);
      setIsEditingBrand(false);
      toastify("success", response.data.message);
    } catch (err) {
      console.error(error);
      toastify("error", error.response.data.message);
    }
  };

  const handleBrandCancel = () => {
    setEditedBrand(selectedBrand);
    setIsEditingBrand(false);
  };

  const handleBrandInputChange = (field, value) => {
    setEditedBrand((prev) => ({ ...prev, [field]: value }));
  };

  const handleBrandColorChange = (index, color) => {
    const newColors = [...editedBrand.colors];
    newColors[index] = color;
    setEditedBrand((prev) => ({ ...prev, colors: newColors }));
  };

  const addBrandColor = () => {
    const newColors = [...editedBrand.colors, "#3B82F6"];
    setEditedBrand((prev) => ({ ...prev, colors: newColors }));
  };

  const removeBrandColor = (index) => {
    // if (editedBrand.colors.length > 2) {
    const newColors = editedBrand.colors.filter((_, i) => i !== index);
    setEditedBrand((prev) => ({ ...prev, colors: newColors }));
    // }
  };

  const handleBrandAIAnalysis = async () => {
    const token = localStorage.getItem("token");
    if (!editedBrand.website) {
      alert("Please enter a website URL first");
      return;
    }
    const payload = {
      brandId: selectedBrand._id,
      websiteUrl: editedBrand.website,
    };
    setIsAnalyzingBrand(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}brands/update-brand-from-website`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );


      const Brand = {
        name: response.data.data.brandName,
        description: response.data.data.description,
        industry: response.data.data.industry,
        colors: response.data.data.brandColors,
        tone: response.data.data.brandToneAndVoice,
        website: response.data.data.url,
        targetMarket: response.data.data.targetMarket,
        uniqueValue:
          "AI-powered automation that learns from your team's workflow",
        mainJob: response.data.data.mainJobOfProduct,
        differentiation: response.data.data.differentiation,
        howItHelps: response.data.data.howItHelps,
        features:
          "Comprehensive project management dashboard.\nReal-time chat and video conferencing capabilities.\nIntegration with popular cloud storage solutions.",
        benefits: response.data.data.benefits,
      };
      // setBrand(Brand);
      setEditedBrand(Brand);
      setIsAnalyzingBrand(false);
      // setIsAnalyzing(false);
      // setIsEditing(false);
      // setApiError("");
      toastify("success", response.data.message);
    } catch (err) {
      // setApiError("Failed to update brand. Please try again.");
      toastify("error", err.response.data.message);
      console.error(err);
    }
  };

  // 1. Add global showAdCopy state
  const [showAdCopy, setShowAdCopy] = useState(true);

  const handleDeleteAction = async () => {
    setIsOpenDelete(true);
    // const userConfirmed = window.confirm("Are you sure? This will delete the original and all its variations");
    // if (userConfirmed) {
    // const token = localStorage.getItem("token");
    // try {
    //   const response = await axios.post(
    //     `${process.env.REACT_APP_API}ads/delete-multiple`,
    //     {
    //       "adIds": [id]
    //     },
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );
    //   toastify("success", response.data.message);
    //   setTimeout(() => {
    //     navigate("/app/ads");
    //   }, 1000);
    // } catch (error) {
    //   console.error(error);
    //   toastify("error", error.response.data.message);
    // }
    // }
  };

  const toggleSelection = (adId) => {
    const newSelection = selectedAds.includes(adId)
      ? selectedAds.filter((id) => id !== adId)
      : [...selectedAds, adId];
    setSelectedAds(newSelection);
  };

  const clearSelection = () => {
    setSelectedAds([]);
  };

  const handleAdClick = (e, adId) => {
    // Stop playback before navigating
    if (playingVideoId && videoRefs.current[playingVideoId]) {
      const oldVideo = videoRefs.current[playingVideoId];
      if (oldVideo.master) oldVideo.master.pause();
      else if (typeof oldVideo.pause === 'function') oldVideo.pause();
    }
    setPlayingVideoId(null);
    setIsVideoPaused(false);

    if (e.target.closest(".selection-checkbox")) {
      toggleSelection(adId);
      return;
    }

    const clickedAd = adsList?.find(a => a._id === adId);
    const videoAd = selectedContentFilter === "video" || isVideoAd(clickedAd);

    if (videoAd) {
      navigate("/app/videoeditor", { state: { videoAdId: adId } });
    } else {
      navigate(`/app/ads/${adId}`);
      window.scrollTo(0, 0); // ⬅️ reset scroll
    }
  };



  const handleMasterPlay = (videoId) => {
    setIsVideoPaused(false);
    const videoRefObj = videoRefs.current[videoId];
    if (videoRefObj) {
      if (videoRefObj.bg) videoRefObj.bg.play().catch(() => { });
      if (videoRefObj.overlay) videoRefObj.overlay.play().catch(() => { });
    }
  };

  const handleMasterPause = (videoId) => {
    setIsVideoPaused(true);
    const videoRefObj = videoRefs.current[videoId];
    if (videoRefObj) {
      if (videoRefObj.bg) videoRefObj.bg.pause();
      if (videoRefObj.overlay) videoRefObj.overlay.pause();
    }
  };

  const handleMasterSeek = (e, videoId) => {
    const time = e.target.currentTime;
    const videoRefObj = videoRefs.current[videoId];
    if (videoRefObj) {
      if (videoRefObj.bg) videoRefObj.bg.currentTime = time;
      if (videoRefObj.overlay) videoRefObj.overlay.currentTime = time;
    }
  };

  useEffect(() => {
    if (!playingVideoId) return;
    const videoRefObj = videoRefs.current[playingVideoId];
    if (!videoRefObj) return;

    // For talking-head videos we control play/pause manually via the master video.
    // For regular videos, autoPlay handles initial playback; we only intervene
    // after the video is already loaded to avoid fighting the browser's autoplay.
    if (!isVideoPaused) {
      if (videoRefObj.master) videoRefObj.master.play().catch(() => { });
      // For regular videos, don't call .play() here — autoPlay already does it,
      // and calling it again on mount races with the browser and causes the
      // "need two clicks" symptom.
    } else {
      if (videoRefObj.master) videoRefObj.master.pause();
      else if (typeof videoRefObj.pause === 'function') videoRefObj.pause();
    }
  }, [playingVideoId, isVideoPaused]);

  const renderImageCard = (ad) => {
    const hasImage = ad.imageUrl && ad.imageUrl.trim() !== "";
    const coverImageFound = ad?.imageVariations?.find(
      (variation) => variation?.url === ad?.imageUrl
    );
    const isSelected = selectedAds.includes(ad._id);
    const isTextExpanded = expandedAds.includes(ad._id);
    const isLongText = ad?.adCopyText?.length > 100;
    const displayText = isTextExpanded
      ? ad?.adCopyText
      : ad?.adCopyText?.substring(0, 100)?.trimEnd() + "...";

    return (
      <div
        key={ad._id}
        className={
          showAdCopy
            ? `border mb-4 rounded-3xl shadow-sm duration-300 transition-all overflow-hidden cursor-pointer relative group
                  hover:bg-white/5 hover:shadow-xl hover:shadow-black/50 hover:scale-[1.02]
                  ${isSelected
              ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20"
              : "border-gray-200 bg-white dark:border-gray-700 dark:bg-[#111111]"
            }`
            : "mb-4"
        }
        href={`/app/ads/${ad._id}`}
        onClick={(e) => handleAdClick(e, ad._id)}
      >
        {showAdCopy && (
          <>
            <div
              className={`absolute top-2 left-2 z-10 selection-checkbox ${isSelected || "group-hover:opacity-100 opacity-0"
                } transition-opacity`}
              onClick={(e) => {
                e.stopPropagation();
                toggleSelection(ad._id);
              }}
            >
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center ${isSelected
                  ? "bg-blue-600 border-blue-600"
                  : "bg-white dark:bg-[#0A0A0A] border-gray-300 dark:border-gray-600 hover:border-blue-400"
                  }`}
              >
                {isSelected && (
                  <svg
                    className="w-3 h-3 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
            <div className="flex items-center justify-between p-4 pb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
                  <span className="text-white font-bold text-sm">
                    {ad?.brandId?.brandName?.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
                    {ad?.brandId?.brandName}
                  </div>
                </div>
              </div>

              <Menu as="div" className="relative">
                <Menu.Button
                  onClick={(e) => e.stopPropagation()}
                  className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-white/10 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
                >
                  <MoreVertical className="w-5 h-5" />
                </Menu.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-32 origin-top-right rounded-lg bg-white dark:bg-[#1a1a1a] shadow-lg ring-1 ring-black/5 focus:outline-none z-50 overflow-hidden border border-gray-100 dark:border-white/5">
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={(e) => handleDeleteAdClick(e, ad)}
                          className={`${active ? "bg-red-50 dark:bg-red-500/10 text-red-600" : "text-gray-700 dark:text-gray-300"} group flex w-full items-center px-3 py-2 text-sm transition-colors`}
                        >
                          <Trash2 className="mr-2 h-4 w-4" />
                          Delete
                        </button>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
            <hr className="dark:border-gray-700" />
            <div className="px-4 pb-3  mt-2">
              <div className="text-gray-900 dark:text-[#fff] text-sm leading-relaxed">
                <span className="whitespace-pre-line text-black dark:text-gray-300">
                  {displayText}
                </span>
                {isLongText && (
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleExpand(ad?._id);
                    }}
                    className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 ml-2 font-medium z-50"
                  >
                    {isTextExpanded ? "See less" : "See more"}
                  </button>
                )}
                {isTextExpanded && (
                  <button
                    className="flex items-center gap-1 px-2 py-1 border border-orange-200 dark:border-orange-800 bg-orange-100 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300 rounded hover:bg-orange-200 dark:hover:bg-orange-900/30 text-xs font-medium mt-1"
                    type="button"
                    onClick={async (e) => {
                      e.stopPropagation();
                      try {
                        await navigator.clipboard.writeText(
                          `${ad?.headline}\n${ad?.adCopyText}`
                        );
                        toast.success("Copied to clipboard");
                      } catch {
                        alert("Failed to copy text to clipboard");
                      }
                    }}
                  >
                    <svg
                      className="w-3 h-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 16h8M8 12h8m-8-4h8M4 6h16M4 10h16M4 14h16M4 18h16"
                      />
                    </svg>
                    Copy
                  </button>
                )}
              </div>
            </div>
          </>
        )}

        <div
          className={`relative flex h-full w-full items-center justify-center overflow-hidden  `}
        >
          {hasImage ? (
            <img
              src={ad.imageUrl}
              alt="Ad"
              className={`${!showAdCopy ? "rounded-3xl" : ""} ${(coverImageFound?.size === "1024x1024" || coverImageFound?.size === "1:1")
                ? "max-h-full max-w-full aspect-square object-cover"
                : (coverImageFound?.size === "1024x1536" || coverImageFound?.size === "9:16")
                  ? "w-full max-h-[450px] aspect-[9/16] object-cover"
                  : coverImageFound?.size === "4:5"
                    ? "w-full max-h-[400px] aspect-[4/5] object-cover"
                    : (coverImageFound?.size === "1536x1024" || coverImageFound?.size === "16:9")
                      ? "w-full aspect-video object-cover"
                      : "max-h-full max-w-full object-cover"
                } border border-gray-200 dark:border-gray-700 ring-1 ring-gray-200 dark:ring-gray-700`}
            />
          ) : (
            ""
          )}

          <div
            className={`absolute rounded-lg flex items-center justify-center top-2 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 h-7 w-7 dark:bg-[#111111]/90 dark:hover:bg-[#111111] dark:text-white border border-white/10 bg-white/90 hover:bg-white text-gray-900 border-gray-200"`}
            onClick={(e) => e.stopPropagation()}
          >
            <a
              href={ad?.brandId?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkIcon className="h-4 w-4" />
            </a>
          </div>

          {/* Variation Counter */}
          {ad?.imageVariations?.length > 1 && (
            <div
              className="absolute bottom-2 left-2 bg-orange-500 text-white text-[10px] px-2 py-1 rounded-md z-50 flex items-center font-medium"
              onClick={(e) => e.stopPropagation()}
            >
              {ad?.imageVariations?.length || 0} variations
            </div>
          )}
          <div
            className={`absolute bottom-2 right-2 bg-white dark:bg-[#0A0A0A] rounded-md px-2 py-1 text-[10px] font-medium text-gray-500 dark:text-[#fff] flex items-center border border-gray-200 dark:border-gray-700`}
          >
            {(coverImageFound?.size === "1024x1024" || coverImageFound?.size === "1:1") ? (
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1"
              >
                <rect x="0.5" y="0.5" width="9" height="9" rx="1" stroke="currentColor" fill="none" />
              </svg>
            ) : (coverImageFound?.size === "1024x1536" || coverImageFound?.size === "9:16") ? (
              <svg
                width="6"
                height="12"
                viewBox="0 0 6 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1"
              >
                <rect x="0.5" y="0.5" width="5" height="11" rx="1" stroke="currentColor" fill="none" />
              </svg>
            ) : (coverImageFound?.size === "4:5") ? (
              <svg
                width="8"
                height="10"
                viewBox="0 0 8 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1"
              >
                <rect x="0.5" y="0.5" width="7" height="9" rx="1" stroke="currentColor" fill="none" />
              </svg>
            ) : (
              <svg
                width="12"
                height="8"
                viewBox="0 0 16 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-1"
              >
                <rect x="0.5" y="0.5" width="15" height="8" rx="1" stroke="currentColor" fill="none" />
              </svg>
            )}

            {(coverImageFound?.size === "1024x1024" || coverImageFound?.size === "1:1")
              ? "1:1"
              : (coverImageFound?.size === "1024x1536" || coverImageFound?.size === "9:16")
                ? "9:16"
                : (coverImageFound?.size === "4:5")
                  ? "4:5"
                  : "16:9"}
          </div>
        </div>

        {showAdCopy && (
          <>
            <div className="border-t border-gray-200 dark:border-gray-700"></div>
            <div className="p-3">
              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide font-medium ">
                  {ad?.brandId?.url
                    ? new URL(ad?.brandId?.url).hostname
                    : ""}
                </div>
                <h3 className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
                  {ad.headline}
                </h3>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 truncate">
                  {ad.description}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  const renderVideoCard = (video) => {
    const videoUrl = video.video?.url || video.videoUrl;
    const hasVideo = videoUrl && videoUrl.trim() !== "";
    const isSelected = selectedAds.includes(video._id);
    expandedAds.includes(video._id);



    return (
      <div
        key={video._id}
        className={`border mb-4 rounded-3xl shadow-sm duration-300 transition-all overflow-hidden cursor-pointer relative group
                hover:bg-white/5 hover:shadow-xl hover:shadow-black/50 hover:scale-[1.02]
                ${isSelected
            ? "border-blue-500 bg-blue-50 dark:bg-blue-900/20"
            : "border-gray-200 bg-white dark:border-gray-700 dark:bg-[#111111]"
          }`}
        onClick={(e) => handleAdClick(e, video._id)}
      >
        {/* Selection Checkbox */}
        <div
          className={`absolute top-2 left-2 z-10 selection-checkbox ${isSelected || "group-hover:opacity-100 opacity-0"
            } transition-opacity`}
          onClick={(e) => {
            e.stopPropagation();
            toggleSelection(video._id);
          }}
        >
          <div
            className={`w-5 h-5 rounded border-2 flex items-center justify-center ${isSelected
              ? "bg-blue-600 border-blue-600"
              : "bg-white dark:bg-[#0A0A0A] border-gray-300 dark:border-gray-600 hover:border-blue-400"
              }`}
          >
            {isSelected && (
              <svg
                className="w-3 h-3 text-white"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </div>

        {/* Brand Header */}
        <div className="flex items-center justify-between p-4 pb-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
              <span className="text-white font-bold text-sm">
                {video?.brandId?.brandName?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <div className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
                {video?.brandId?.brandName}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {video?.characterId?.name &&
                  `Avatar: ${video.characterId.name}`}
              </div>
            </div>
          </div>

          <Menu as="div" className="relative">
            <Menu.Button
              onClick={(e) => e.stopPropagation()}
              className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-white/10 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              <MoreVertical className="w-5 h-5" />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-2 w-32 origin-top-right rounded-lg bg-white dark:bg-[#1a1a1a] shadow-lg ring-1 ring-black/5 focus:outline-none z-50 overflow-hidden border border-gray-100 dark:border-white/5">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={(e) => handleDeleteAdClick(e, video)}
                      className={`${active ? "bg-red-50 dark:bg-red-500/10 text-red-600" : "text-gray-700 dark:text-gray-300"} group flex w-full items-center px-3 py-2 text-sm transition-colors`}
                    >
                      <Trash2 className="mr-2 h-4 w-4" />
                      Delete
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>

        <hr className="dark:border-gray-700" />

        {/* Video Player / Poster */}
        <div className="relative flex h-full w-full items-center justify-center overflow-hidden min-h-[200px]">
          {isIOS && hasVideo ? (
            <AdVideoPlayer
              key={`${video._id}:${videoUrl}`}
              ad={video}
              onVideoElement={registerPreviewVideo}
              onPlayRequest={startPreviewVideo}
              onPause={pausePreviewVideo}
            />
          ) : video.adType === 'talking_head' ? (() => {
            const hasBg = Boolean(video.backgroundMedia?.url);
            const hasOverlay = Boolean(video.video?.url);
            const bgReady = !hasBg || Boolean(videoLoaded[`${video._id}-bg`]);
            const overlayReady = !hasOverlay || Boolean(videoLoaded[`${video._id}-overlay`]);
            const allLayersReady = bgReady && overlayReady;
            return (
              <div
                className="relative w-full aspect-[9/16] bg-black overflow-hidden group/talking-head cursor-pointer"
                onClick={(e) => {
                  if (!allLayersReady) return;
                  e.stopPropagation();
                  if (playingVideoId !== video._id) {
                    setPlayingVideoId(video._id);
                    setIsVideoPaused(false);
                  }
                }}
              >
                {/* Background Layer */}
                {hasBg && (
                  <div
                    className="absolute w-full h-full"
                    style={{
                      left: `${(video.backgroundMedia.appearance?.x || 0.5) * 100}%`,
                      top: `${(video.backgroundMedia.appearance?.y || 0.5) * 100}%`,
                      transform: `translate(-50%, -50%) scale(${video.backgroundMedia.appearance?.scale || 1}) rotate(${video.backgroundMedia.appearance?.rotation || 0}deg)`,
                      opacity: video.backgroundMedia.appearance?.opacity ?? 1,
                    }}
                  >
                    {video.backgroundMedia.type === 'video' ? (
                      <video
                        src={video.backgroundMedia.url}
                        className="w-full h-full object-cover"
                        autoPlay={playingVideoId === video._id && !isVideoPaused}
                        muted={true}
                        loop
                        playsInline
                        preload="metadata"
                        onLoadedData={() => setVideoLoaded(prev => ({ ...prev, [`${video._id}-bg`]: true }))}
                        onError={() => setVideoLoaded(prev => ({ ...prev, [`${video._id}-bg`]: true }))}
                        ref={(el) => {
                          if (el) {
                            if (typeof videoRefs.current[video._id] !== "object" || videoRefs.current[video._id] === null) {
                              videoRefs.current[video._id] = {};
                            }
                            videoRefs.current[video._id].bg = el;
                            if (playingVideoId === video._id) {
                              if (isVideoPaused) el.pause();
                              else el.play().catch(() => { });
                            }
                          }
                        }}
                      />
                    ) : (
                      <img
                        src={video.backgroundMedia.url}
                        className="w-full h-full object-cover"
                        alt="Background"
                        onLoad={() => setVideoLoaded(prev => ({ ...prev, [`${video._id}-bg`]: true }))}
                      />
                    )}
                  </div>
                )}
                {/* Talking Head Layer */}
                {hasOverlay && (
                  <div
                    className="absolute w-full h-full"
                    style={{
                      left: `${(video.video.appearance?.x || 0.5) * 100}%`,
                      top: `${(video.video.appearance?.y || 0.5) * 100}%`,
                      transform: `translate(-50%, -50%) scale(${video.video.appearance?.scale || 1}) rotate(${video.video.appearance?.rotation || 0}deg)`,
                      opacity: video.video.appearance?.opacity ?? 1,
                      zIndex: 10,
                    }}
                  >
                    <video
                      src={video.video.url}
                      className="w-full h-full object-contain"
                      autoPlay={playingVideoId === video._id && !isVideoPaused}
                      muted={true}
                      loop
                      playsInline
                      preload="metadata"
                      onLoadedData={() => setVideoLoaded(prev => ({ ...prev, [`${video._id}-overlay`]: true }))}
                      onError={() => setVideoLoaded(prev => ({ ...prev, [`${video._id}-overlay`]: true }))}
                      ref={(el) => {
                        if (el) {
                          if (typeof videoRefs.current[video._id] !== "object" || videoRefs.current[video._id] === null) {
                            videoRefs.current[video._id] = {};
                          }
                          videoRefs.current[video._id].overlay = el;
                          if (playingVideoId === video._id) {
                            if (isVideoPaused) el.pause();
                            else el.play().catch(() => { });
                          }
                        }
                      }}
                    />
                  </div>
                )}

                {/* Loading Overlay — only shown while layers that exist haven't loaded yet */}
                {(!allLayersReady || videoBuffering[video._id]) && (
                  <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-800/50 z-30 pointer-events-none">
                    <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mb-2"></div>
                    <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">
                      {videoBuffering[video._id] ? "Buffering..." : "Loading..."}
                    </span>
                  </div>
                )}

                {/* Play/Pause Overlay (Center) */}
                {allLayersReady && !videoBuffering[video._id] && (playingVideoId !== video._id || (isVideoPaused && !isSeeking[video._id])) && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover/talking-head:bg-black/40 transition-colors pointer-events-none z-20">
                    <div
                      className="w-12 h-12 rounded-full bg-[#F4F4F5] flex items-center justify-center text-[#101828] shadow-lg transform group-hover/talking-head:scale-110 transition-transform cursor-pointer pointer-events-auto"
                      onClick={(e) => {
                        e.stopPropagation();

                        // Pause previously playing video
                        if (playingVideoId && videoRefs.current[playingVideoId]) {
                          const oldVideo = videoRefs.current[playingVideoId];
                          if (oldVideo.master) oldVideo.master.pause();
                          else if (typeof oldVideo.pause === 'function') oldVideo.pause();
                        }

                        if (playingVideoId !== video._id) {
                          setPlayingVideoId(video._id);
                          setIsVideoPaused(false);
                        } else {
                          setIsVideoPaused(false);
                        }

                        const el = videoRefs.current[video._id]?.master;
                        if (el && typeof el.play === 'function') {
                          el.play().catch(() => { });
                        }
                      }}
                    >
                      <Play className="w-6 h-6 fill-white ml-0.5" />
                    </div>
                  </div>
                )}

                {/* Card Level Controls for Talking Head (Native Look) */}
                <video
                  src={video.video.url}
                  controls={playingVideoId === video._id}
                  muted={isMuted}
                  preload="metadata"
                  playsInline
                  className={`absolute inset-0 w-full h-full z-40 bg-transparent ${playingVideoId === video._id ? 'pointer-events-auto' : 'pointer-events-none'}`}
                  style={{ objectPosition: "-9999px -9999px", opacity: playingVideoId === video._id ? 1 : 0 }}
                  onPlay={() => handleMasterPlay(video._id)}
                  onPause={() => handleMasterPause(video._id)}
                  onWaiting={() => setVideoBuffering(prev => ({ ...prev, [video._id]: true }))}
                  onPlaying={() => {
                    setVideoBuffering(prev => ({ ...prev, [video._id]: false }));
                    setIsVideoPaused(false);
                  }}
                  onSeeking={(e) => {
                    setIsSeeking(prev => ({ ...prev, [video._id]: true }));
                    handleMasterSeek(e, video._id);
                  }}
                  onSeeked={(e) => {
                    handleMasterSeek(e, video._id);
                    setIsSeeking(prev => ({ ...prev, [video._id]: false }));
                  }}
                  onTimeUpdate={(e) => handleMasterSeek(e, video._id)}
                  ref={(el) => {
                    if (el) {
                      if (typeof videoRefs.current[video._id] !== "object" || videoRefs.current[video._id] === null) {
                        videoRefs.current[video._id] = {};
                      }
                      videoRefs.current[video._id].master = el;
                    }
                  }}
                />
              </div>
            );
          })() : hasVideo ? (
            <div className="relative w-full aspect-[9/16] bg-black group/play overflow-hidden">
              {/* Always mount video for background buffering */}
              <video
                ref={(el) => (videoRefs.current[video._id] = el)}
                src={videoUrl}
                controls={playingVideoId === video._id}
                muted={isMuted}
                playsInline
                preload="metadata"
                onClick={(e) => e.stopPropagation()}
                className={`ads-list-video-player absolute inset-0 w-full h-full object-cover transition-opacity duration-300 z-10 ${playingVideoId === video._id ? 'opacity-100' : 'opacity-0'}`}
                onPlay={() => {
                  if (playingVideoId === video._id) setIsVideoPaused(false);
                }}
                onPause={() => {
                  if (playingVideoId === video._id) setIsVideoPaused(true);
                }}
                onSeeking={() => setIsSeeking(prev => ({ ...prev, [video._id]: true }))}
                onSeeked={() => setIsSeeking(prev => ({ ...prev, [video._id]: false }))}
              />

              {/* Poster/GIF Overlay */}
              <img
                src={video.gifUrl || video.video?.thumbnail}
                alt={video.videoTitle}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 z-0 pointer-events-none ${playingVideoId === video._id ? 'opacity-0' : 'opacity-100'}`}
              />

              {/* Play/Pause Overlay when Playing and Paused */}
              {playingVideoId === video._id && isVideoPaused && !isSeeking[video._id] && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover/play:bg-black/40 transition-colors pointer-events-none z-20">
                  <div
                    className="w-12 h-12 rounded-full bg-[#F4F4F5] flex items-center justify-center text-[#101828] shadow-lg transform hover:scale-110 transition-transform cursor-pointer pointer-events-auto"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsVideoPaused(false);
                      const el = videoRefs.current[video._id];
                      if (el && typeof el.play === 'function') {
                        el.play().catch(() => { });
                      }
                    }}
                  >
                    <Play className="w-6 h-6 fill-white ml-0.5" />
                  </div>
                </div>
              )}

              {/* Initial Play Button Overlay when NOT Playing */}
              {playingVideoId !== video._id && (
                <div
                  className="absolute inset-0 flex items-center justify-center  group-hover/play:bg-black/40 transition-colors cursor-pointer z-20"
                  onClick={(e) => {
                    e.stopPropagation();

                    // Pause previously playing video
                    if (playingVideoId && videoRefs.current[playingVideoId]) {
                      const oldVideo = videoRefs.current[playingVideoId];
                      if (oldVideo.master) oldVideo.master.pause();
                      else if (typeof oldVideo.pause === 'function') oldVideo.pause();
                    }

                    setIsVideoPaused(false);
                    setIsSeeking(false);
                    setPlayingVideoId(video._id);

                    const el = videoRefs.current[video._id];
                    if (el && typeof el.play === 'function') {
                      el.play().catch(() => { });
                    }
                  }}
                >
                  <div className="w-14 h-14 rounded-full bg-[#F4F4F5] flex items-center justify-center shadow-lg transition-transform duration-200 hover:scale-110">
                    <Play className="h-7 w-7 text-[#101828] ml-1" fill="white" strokeWidth={1.75} />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="w-full aspect-video bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
              <span className="text-gray-400">No video available</span>
            </div>
          )}

          {/* Link Icon */}
          <div
            className="absolute rounded-lg flex items-center justify-center top-2 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 h-7 w-7 dark:bg-[#111111]/90 dark:hover:bg-[#111111] dark:text-white border border-white/10 bg-white/90 hover:bg-white text-gray-900 border-gray-200"
            onClick={(e) => e.stopPropagation()}
          >
            <a
              href={video?.brandId?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkIcon className="h-4 w-4" />
            </a>
          </div>

          {/* Variation Counter */}
          {video?.variations?.length > 0 && (
            <div
              className={`absolute bottom-2 left-2 bg-orange-500 text-white text-[10px] px-2 py-1 rounded-md z-50 flex items-center font-medium transition-opacity duration-300 ${playingVideoId === video._id ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
              onClick={(e) => e.stopPropagation()}
            >
              {(video.variations.length || 0) + 1} variations
            </div>
          )}

          {/* Video Orientation Badge */}
          {video.videoOrientation && (
            <div className={`absolute bottom-2 right-2 z-50 bg-white dark:bg-[#0A0A0A] rounded-md px-2 py-1 text-[10px] font-medium text-gray-500 dark:text-[#fff] flex items-center border border-gray-200 dark:border-gray-700 transition-opacity duration-300 ${playingVideoId === video._id ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
              {video.videoOrientation === "portrait" ? (
                <>
                  <svg
                    width="6"
                    height="12"
                    viewBox="0 0 6 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-1"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="5"
                      height="11"
                      rx="1"
                      stroke="currentColor"
                      fill="none"
                    />
                  </svg>
                  9:16
                </>
              ) : (
                <>
                  <svg
                    width="12"
                    height="8"
                    viewBox="0 0 16 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-1"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="15"
                      height="8"
                      rx="1"
                      stroke="currentColor"
                      fill="none"
                    />
                  </svg>
                  16:9
                </>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 dark:border-gray-700"></div>
        <div className="p-3">
          <div>
            <div className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide font-medium">
              {video?.brandId?.url
                ? new URL(video?.brandId?.url).hostname
                : "Video Ad"}
            </div>
            <h3 className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
              {video.videoTitle || "Untitled Video"}
            </h3>
            {video.type && (
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                {video.type}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  const renderMixedGrid = (items = adsList, showSkeletons = true) => (
    <div className="space-y-4 relative">
      {selectedAds.length > 0 && (
        <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <span className="text-blue-800 dark:text-blue-200 font-medium">
              {selectedAds.length} items selected
            </span>
            <button
              onClick={clearSelection}
              className="text-blue-600 dark:text-blue-400 border border-blue-300 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/30 px-3 py-1 rounded text-sm flex items-center gap-1"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              Clear selection
            </button>
          </div>
          <button
            onClick={handleDeleteAction}
            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
            Delete selected
          </button>
        </div>
      )}

      <Masonry
        breakpointCols={breakpointColumns}
        className="flex -ml-4 w-auto"
        columnClassName="pl-4 bg-clip-padding"
      >
        {(inProcessAds > 0 || (loading && items?.length === 0)) && showSkeletons &&
          Array.from({ length: inProcessAds > 0 ? inProcessAds : 5 }, (_, index) => (
            <ImageSkeletonCard key={"skeleton-" + index} />
          ))}
        {items?.map((item) => {
          if (isVideoAd(item)) return renderVideoCard(item);
          return renderImageCard(item);
        })}
      </Masonry>
    </div>
  );

  // 3. Add show/hide copy and copy-to-clipboard UI in renderAdGrid
  const renderAdGrid = (items = adsList, showSkeletons = true) => (
    <div className="space-y-4 relative">
      {/* Selection Header */}
      {selectedAds.length > 0 && (
        <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <span className="text-blue-800 dark:text-blue-200 font-medium">
              {selectedAds.length} ad{selectedAds.length !== 1 ? "s" : ""}{" "}
              selected
            </span>
            <button
              onClick={clearSelection}
              className="text-blue-600 dark:text-blue-400 border border-blue-300 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/30 px-3 py-1 rounded text-sm flex items-center gap-1"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              Clear selection
            </button>
          </div>
          <button
            onClick={handleDeleteAction}
            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm flex items-center gap-2"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
            Delete selected
          </button>
        </div>
      )}

      {/* Ads Grid */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-4 items-start"> */}
      <Masonry
        breakpointCols={breakpointColumns}
        className="flex -ml-4 w-auto"
        columnClassName="pl-4 bg-clip-padding "
      >
        {(inProcessAds > 0 || (loading && items?.length === 0)) && showSkeletons &&
          Array.from({ length: inProcessAds > 0 ? inProcessAds : 5 }, (_, index) => (
            <ImageSkeletonCard key={`skeleton-${index}`} />
          ))}
        {items?.map(ad => renderImageCard(ad))}
      </Masonry>
    </div>
  );

  const renderVideoGrid = (items = adsList, showSkeletons = true) => (
    <div className="space-y-4 relative">
      {/* Selection Header */}
      {selectedAds.length > 0 && (
        <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <span className="text-blue-800 dark:text-blue-200 font-medium">
              {selectedAds.length} video{selectedAds.length !== 1 ? "s" : ""}{" "}
              selected
            </span>
            <button
              onClick={clearSelection}
              className="text-blue-600 dark:text-blue-400 border border-blue-300 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/30 px-3 py-1 rounded text-sm flex items-center gap-1"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              Clear selection
            </button>
          </div>
          <button
            onClick={handleDeleteAction}
            className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm flex items-center gap-2"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
            Delete selected
          </button>
        </div>
      )}

      {/* Videos Grid */}
      <Masonry
        breakpointCols={breakpointColumns}
        className="flex -ml-4 w-auto"
        columnClassName="pl-4 bg-clip-padding"
      >
        {showSkeletons && inProcessAds > 0 &&
          Array.from({ length: inProcessAds }, (_, index) => (
            <VideoSkeletonCard key={`skeleton-${index}`} />
          ))}
        {showSkeletons && inProcessAds === 0 && loading && items?.length === 0 &&
          Array.from({ length: 4 }, (_, index) => (
            <VideoSkeletonCard key={`skeleton-loading-${index}`} />
          ))}
        {items?.map(video => renderVideoCard(video))}
      </Masonry>
    </div>
  );

  const VideoSkeletonCard = () => (
    <div className="h-fit rounded-xl overflow-hidden border bg-white border-gray-200 dark:bg-white/5 dark:border-white/10">
      <div className="p-3 flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-orange-500/20 animate-pulse"></div>
        <div className="flex-1 space-y-2">
          <div className="h-3 rounded w-1/2 animate-pulse bg-gray-200 dark:bg-white/10"></div>
        </div>
      </div>
      <div className="relative aspect-[9/16] animate-pulse bg-gray-100 dark:bg-white/5">
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <div className="w-10 h-10 rounded-full border-2 border-orange-500/30 border-t-orange-500 animate-spin"></div>
          <p className="text-xs font-medium animate-pulse text-orange-500 dark:text-orange-400">Generating Video...</p>
        </div>
      </div>
      <div className="p-3 space-y-2">
        <div className="h-3 rounded w-3/4 animate-pulse bg-gray-200 dark:bg-white/10"></div>
      </div>
    </div>
  );

  const ImageSkeletonCard = () => (
    <div className="h-fit rounded-xl overflow-hidden border bg-white border-gray-200 dark:bg-white/5 dark:border-white/10">
      <div className="p-3 flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-orange-500/20 animate-pulse"></div>
        <div className="flex-1 space-y-2">
          <div className="h-3 rounded w-1/2 animate-pulse bg-gray-200 dark:bg-white/10"></div>
        </div>
      </div>
      <div className="relative aspect-square animate-pulse bg-gray-100 dark:bg-white/5">
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <div className="w-10 h-10 rounded-full border-2 border-orange-500/30 border-t-orange-500 animate-spin"></div>
          <p className="text-xs font-medium animate-pulse text-orange-500 dark:text-orange-400">Generating Image Ad...</p>
        </div>
      </div>
      <div className="p-3 space-y-2">
        <div className="h-3 rounded w-3/4 animate-pulse bg-gray-200 dark:bg-white/10"></div>
      </div>
    </div>
  );
  const renderBrandInfo = () => (
    <div className="ads-brand-info w-full min-w-0 max-w-6xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-lg bg-gray-100 dark:bg-gray-800 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-gray-600 dark:text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-[#fff] break-words">
              {selectedBrand.name}
            </h1>
            <p className="block max-w-full sm:max-w-[400px] text-gray-600 dark:text-gray-400 truncate overflow-hidden whitespace-nowrap">
              {selectedBrand.description}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 sm:gap-3 w-full sm:w-auto">
          {isEditingBrand && (
            <button
              onClick={handleBrandAIAnalysis}
              disabled={isAnalyzingBrand || !editedBrand.website}
              className="flex-auto sm:flex-none whitespace-nowrap border border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 px-4 py-2 rounded-lg"
            >
              {isAnalyzingBrand ? (
                <span className="animate-spin mr-2">⏳</span>
              ) : (
                <span className="mr-2">🧠</span>
              )}
              AI Website Analysis
            </button>
          )}
          {!isEditingBrand ? (
            <>
              <button
                onClick={handleBrandEdit}
                className="flex-1 sm:flex-none justify-center whitespace-nowrap border border-gray-300 dark:border-gray-600 px-4 py-2 rounded-lg flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
                Edit Brand
              </button>
              <button
                onClick={() => handleGenerateClick()}
                className="flex-1 sm:flex-none justify-center whitespace-nowrap bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                Generate Content
              </button>
            </>
          ) : (
            <>
              <button
                onClick={handleBrandCancel}
                className="flex-auto sm:flex-none justify-center whitespace-nowrap border border-gray-300 dark:border-gray-600 px-4 py-2 rounded-lg flex items-center gap-2 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Cancel
              </button>
              <button
                onClick={handleBrandSave}
                className="flex-auto sm:flex-none justify-center whitespace-nowrap bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                Save Changes
              </button>
            </>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Basic Information */}
        <div className="min-w-0 lg:col-span-2 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6 overflow-hidden">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            Basic Information
          </h3>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Brand Name
                </label>
                {isEditingBrand ? (
                  <input
                    value={editedBrand.name}
                    onChange={(e) =>
                      handleBrandInputChange("name", e.target.value)
                    }
                    className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  />
                ) : (
                  <p className="text-gray-900 dark:text-[#fff] font-medium">
                    {selectedBrand.name}
                  </p>
                )}
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Industry
                </label>
                {isEditingBrand ? (
                  <input
                    value={editedBrand.industry}
                    onChange={(e) =>
                      handleBrandInputChange("industry", e.target.value)
                    }
                    className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  />
                ) : (
                  <span className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded text-sm text-gray-900 dark:text-[#fff]">
                    {selectedBrand.industry}
                  </span>
                )}
              </div>
            </div>
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Description
              </label>
              {isEditingBrand ? (
                <textarea
                  value={editedBrand.description}
                  onChange={(e) =>
                    handleBrandInputChange("description", e.target.value)
                  }
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[80px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                />
              ) : (
                  <p className="text-gray-900 dark:text-[#fff] break-words">
                  {selectedBrand.description}
                </p>
              )}
            </div>
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Website:{" "}
              </label>
              {isEditingBrand ? (
                <input
                  value={editedBrand.website}
                  onChange={(e) =>
                    handleBrandInputChange("website", e.target.value)
                  }
                  className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                  placeholder="https://yourbrand.com"
                />
              ) : (
                <a
                  href={selectedBrand.website}
                  className="block max-w-full break-all text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {selectedBrand.website}
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Brand Colors */}
        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff]">
              Brand Colors
            </h3>
            {isEditingBrand && (
              <button
                type="button"
                onClick={addBrandColor}
                className="border border-gray-300 dark:border-gray-600 px-2 py-1 rounded text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
              >
                Add
              </button>
            )}
          </div>
          <div className="space-y-4">
            {(isEditingBrand ? editedBrand.colors : selectedBrand.colors).map(
              (color, index) => (
                <div key={index} className="space-y-2">
                  <div className="flex items-center justify-between">
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {index === 0 && "Primary Color"}
                      {index === 1 && "Secondary Color"}
                      {index > 1 && `Color ${index + 1}`}
                    </label>
                    {isEditingBrand && (
                      <button
                        type="button"
                        onClick={() => removeBrandColor(index)}
                        className="text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 border border-red-300 dark:border-red-700 rounded px-2 py-1 text-xs"
                      >
                        Remove
                      </button>
                    )}
                  </div>
                  {isEditingBrand ? (
                    <div className="flex min-w-0 gap-2">
                      <input
                        type="color"
                        value={editedBrand.colors[index]}
                        onChange={(e) =>
                          handleBrandColorChange(index, e.target.value)
                        }
                        className="w-12 h-10 rounded border border-gray-300 dark:border-gray-600"
                      />
                      <input
                        value={editedBrand.colors[index]}
                        onChange={(e) =>
                          handleBrandColorChange(index, e.target.value)
                        }
                        className="min-w-0 flex-1 border border-gray-300 dark:border-gray-600 rounded px-3 py-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
                      />
                    </div>
                  ) : (
                    <div className="flex items-center gap-3">
                      <div
                        className="w-8 h-8 rounded border border-gray-300 dark:border-gray-600"
                        style={{ backgroundColor: color }}
                      ></div>
                      <span className="text-gray-700 dark:text-gray-300 font-mono text-sm">
                        {color}
                      </span>
                    </div>
                  )}
                </div>
              )
            )}
          </div>
        </div>
      </div>

      {/* Product Information */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            Main Job of Your Product
          </h3>
          {isEditingBrand ? (
            <textarea
              value={editedBrand.mainJob}
              onChange={(e) =>
                handleBrandInputChange("mainJob", e.target.value)
              }
              className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[120px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
              placeholder="List the main tasks or problems your product helps users solve"
            />
          ) : (
            <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line break-words">
              {selectedBrand.mainJob || "Not specified"}
            </div>
          )}
        </div>

        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            How It Helps
          </h3>
          {isEditingBrand ? (
            <textarea
              value={editedBrand.howItHelps}
              onChange={(e) =>
                handleBrandInputChange("howItHelps", e.target.value)
              }
              className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[120px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
              placeholder="Explain how your product helps users achieve their goals"
            />
          ) : (
            <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line break-words">
              {selectedBrand.howItHelps || "Not specified"}
            </div>
          )}
        </div>

        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            Differentiation
          </h3>
          {isEditingBrand ? (
            <textarea
              value={editedBrand.differentiation}
              onChange={(e) =>
                handleBrandInputChange("differentiation", e.target.value)
              }
              className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[120px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
              placeholder="Explain what makes your product unique compared to alternatives"
            />
          ) : (
            <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line break-words">
              {selectedBrand.differentiation || "Not specified"}
            </div>
          )}
        </div>

        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            Benefits
          </h3>
          {isEditingBrand ? (
            <textarea
              value={editedBrand.benefits}
              onChange={(e) =>
                handleBrandInputChange("benefits", e.target.value)
              }
              className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[120px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
              placeholder="List the key benefits of your product"
            />
          ) : (
            <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line break-words">
              {selectedBrand.benefits || "Not specified"}
            </div>
          )}
        </div>

        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            Features
          </h3>
          {isEditingBrand ? (
            <textarea
              value={editedBrand.features}
              onChange={(e) =>
                handleBrandInputChange("features", e.target.value)
              }
              className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[120px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
              placeholder="List the key features of your product"
            />
          ) : (
            <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line break-words">
              {selectedBrand.features || "Not specified"}
            </div>
          )}
        </div>

        <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
          <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
            Target Market
          </h3>
          {isEditingBrand ? (
            <textarea
              value={editedBrand.targetMarket}
              onChange={(e) =>
                handleBrandInputChange("targetMarket", e.target.value)
              }
              className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full min-h-[120px] bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
              placeholder="Describe your primary target audience"
            />
          ) : (
            <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line break-words">
              {selectedBrand.targetMarket || "Not specified"}
            </div>
          )}
        </div>
      </div>

      {/* Brand Voice */}
      <div className="min-w-0 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
        <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-4">
          Brand Tone & Voice
        </h3>
        {isEditingBrand ? (
          <input
            value={editedBrand.tone}
            onChange={(e) => handleBrandInputChange("tone", e.target.value)}
            className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full bg-white dark:bg-gray-800 text-gray-900 dark:text-[#fff]"
            placeholder="e.g., Professional, friendly, innovative"
          />
        ) : (
          <p className="text-gray-700 dark:text-gray-300 break-words">
            {selectedBrand.tone}
          </p>
        )}
      </div>

      {/* Quick Actions */}
      {isEditingBrand && (
        <div className="min-w-0 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="min-w-0">
            <h3 className="text-md font-semibold text-gray-900 dark:text-[#fff] mb-2">
              Ready to create content?
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              Use this comprehensive brand profile to generate targeted content
              for your audience.
            </p>
          </div>
          <button
            disabled={!isEditingBrand}
            onClick={() => {
              handleBrandSave();
              handleGenerateClick();
            }}
            className="w-full sm:w-auto flex-shrink-0 justify-center whitespace-nowrap bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
          >
            <span className="text-xl">✨</span>
            Save & Generate content
          </button>
        </div>
      )}
    </div>
  );

  const normalizedContentSearch = contentSearch.trim().toLowerCase();
  const visibleAds = normalizedContentSearch
    ? adsList.filter((ad) => [
      ad?.brandId?.brandName,
      ad?.adCopyText,
      ad?.description,
      ad?.videoTitle,
      ad?.title,
      ad?.characterId?.name,
    ].some((value) => String(value || "").toLowerCase().includes(normalizedContentSearch)))
    : adsList;

  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : (
        <div className="responsive-page responsive-page--ads flex-1 bg-[#fff] dark:bg-[#0A0A0A]">
          <div className="p-6 pb-0">
            <div className="ads-page-header flex items-center justify-between mb-6">
              <div className="ads-page-title-search flex justify-center items-center gap-3">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-[#fff]">
                  AI Studio
                </h1>
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500 dark:text-white z-10" />
                  <input
                    type="text"
                    placeholder="Search content..."
                    aria-label="Search AI Studio content"
                    value={contentSearch}
                    onChange={(event) => setContentSearch(event.target.value)}
                    className="w-[280px] pl-9 pr-9 h-9 rounded-xl 
      bg-white border border-gray-200 text-gray-900 placeholder:text-gray-400 
      focus:outline-none focus:ring-0 focus:border-gray-500
      dark:bg-white/5 dark:border-white/10 dark:text-white dark:placeholder:text-gray-500 dark:focus:border-gray-500"
                  />
                </div>
              </div>
              <div className="ads-page-header-actions flex items-center gap-3">
                <div className="relative" ref={dropdownRef}>
                  <div className="relative">
                    <button
                      className="w-64 px-4 py-1 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-600 dark:text-[#fff] hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center justify-between"
                      onClick={() => setShowBrandDropdown(!showBrandDropdown)}
                    >
                      <span className="truncate w-64 overflow-hidden whitespace-nowrap dark:text-[#fff]">
                        {selectedBrand.internalName || selectedBrand.name}
                      </span>
                      <svg
                        className="h-5 w-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>

                    {showBrandDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 dark:text-[#fff] dark:bg-[#0A0A0A] dark:hover:bg-gray-800 bg-white border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg z-50 max-h-80 overflow-hidden">
                        {/* Search input */}
                        <div className="p-3 border-b border-gray-300 dark:border-gray-600 dark:text-[#fff]">
                          <div className="relative">
                            <svg
                              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                              />
                            </svg>
                            <input
                              placeholder="Search brands..."
                              value={brandSearchTerm}
                              onChange={(e) =>
                                setBrandSearchTerm(e.target.value)
                              }
                              className="pl-10 h-9 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded text-gray-900 dark:text-[#fff] placeholder-gray-500 dark:placeholder-gray-400 focus:border-gray-400 dark:focus:border-gray-500 focus:ring-0 w-full"
                            />
                          </div>
                        </div>

                        {/* Brand list */}
                        <div className="max-h-60 overflow-y-auto dark:text-[#fff]">
                          {filteredBrands.length > 0 ? (
                            filteredBrands.map((brand, index) => (
                              <button
                                key={index}
                                onClick={() => handleBrandSelect(brand._id)}
                                className="w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center gap-2 text-gray-900 dark:text-[#fff]"
                              >
                                {selectedBrand._id === brand._id ? (
                                  <span className="text-green-500">✓</span>
                                ) : (
                                  <span className="w-4"></span>
                                )}
                                <span>{brand.internalName || brand.brandName}</span>
                              </button>
                            ))
                          ) : (
                            <div className="px-4 py-6 text-center text-gray-400 dark:text-gray-500">
                              <div className="text-sm">No brands found</div>
                              <div className="text-xs">
                                Try adjusting your search
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <button
                  className="p-2 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 "
                  onClick={handleCreateBrand}
                  title="Create New Brand"
                >
                  <svg
                    className="h-3 w-3 text-gray-500 dark:text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                </button>
                {activeTab === "my-content" &&
                  (selectedContentFilter === "automation" ? (
                    // Automation-specific button
                    <button
                      onClick={() => setShowCreateModal(true)}
                      className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-1 rounded-lg dark:text-[#fff]"
                    >
                      Create Autopilot
                    </button>
                  ) : (
                    // Regular content button (includes video and ads)
                    <button
                      onClick={handleCreateContent}
                      className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-1 rounded-lg dark:text-[#fff]"
                    >
                      Create{" "}
                      {contentTypes.find((t) => t?.id === selectedContentFilter)
                        ?.name || "Content"}
                    </button>
                  ))}
                {activeTab === "my-content" && selectedAds.length > 0 && (
                  <button
                    onClick={handleDeleteSelected}
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 hidden"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                    Delete ({selectedAds.length})
                  </button>
                )}
              </div>
            </div>

            <div className="ads-page-tabs border-b border-gray-200 dark:border-gray-700">
              <div className="ads-page-tabs-row flex items-center justify-between">
                <nav className="ads-page-tab-list flex">
                  <button
                    onClick={() => setActiveTab("my-content")}
                    className={`px-6 py-4 text-md font-medium ${activeTab === "my-content"
                      ? "border-b-2 border-orange-500 text-gray-900 dark:text-[#fff]"
                      : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-[#fff]"
                      }`}
                  >
                    My Content
                  </button>
                  <button
                    onClick={() => setActiveTab("brand-info")}
                    className={`px-6 py-4 text-md font-medium ${activeTab === "brand-info"
                      ? "border-b-2 border-orange-500 text-gray-900 dark:text-[#fff]"
                      : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-[#fff]"
                      }`}
                  >
                    Brand Info
                  </button>
                </nav>
                <div className="ads-page-tab-actions flex items-center justify-between gap-4">
                  {/* <Menu as="div" className="relative inline-block text-left">

                    <Menu.Button
                      className={`flex items-center justify-between gap-2 h-9 px-4 rounded-xl border transition-all duration-200 text-sm font-medium dark:bg-white/5 dark:border-[#161616] dark:text-gray-300 dark:hover:bg-white/10 dark:hover:text-white bg-white border-gray-200 text-gray-700 hover:bg-gray-50
                      `}
                      style={{ outline: "none", boxShadow: "none" }}
                    >
                      <span>
                        {selected === "video"
                          ? "Video"
                          : selected === "image"
                            ? "Image"
                            : "Select Format"}
                      </span>
                      <ChevronDown className="h-4 w-4" />
                    </Menu.Button>


                    <Menu.Items
                      className={`absolute mt-2 w-44 rounded-xl shadow-lg p-1 z-20 border dark:bg-[#111111] dark:border-[#161616]
                        bg-white border-gray-200
                      `}
                    >
                      {optionsFormat?.map((option) => (
                        <Menu.Item key={option}>
                          {({ active }) => (
                            <button
                              onClick={() => setSelected(option)}
                              className={`
    flex items-center gap-2 w-full text-left rounded-lg px-3 py-2 text-sm transition
    text-gray-900 dark:text-white
    ${active ? "bg-gray-100 dark:bg-white/10" : ""}
  `}
                            >

                              <span
                                className={`relative h-3.5 w-3.5 rounded-full border flex items-center justify-center ${selected === option
                                  ? "border-none"
                                  : "dark:border-gray-500 border-gray-400"
                                  }`}
                              >
                                {selected === option && (
                                  <span className="absolute h-3 w-3 rounded-full bg-orange-500" />
                                )}
                              </span>
                              {option.charAt(0).toUpperCase() + option.slice(1)}
                            </button>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Menu> */}

                  <Menu as="div" className="relative inline-block text-left">
                    {/* Trigger Button */}
                    <Menu.Button
                      className="inline-flex items-center justify-center gap-2 h-9 px-4 py-5 rounded-xl border transition-all duration-200
        bg-white border-gray-200 text-gray-700 hover:bg-gray-50
        dark:bg-white/5 dark:border-[#161616] dark:text-gray-300 dark:hover:bg-white/10 dark:hover:text-white
        focus:outline-none focus:ring-0 focus:border-[#161616]"
                    >
                      <span className="text-sm font-medium">
                        {sortLabels[sortBy]}
                      </span>
                      <ChevronDown className="h-4 w-4" />
                    </Menu.Button>

                    {/* Dropdown Menu */}
                    <Menu.Items
                      className="absolute right-0 mt-2 w-52 origin-top-right rounded-xl border shadow-lg
        bg-white border-gray-200
        dark:bg-[#111111] dark:border-[#161616]
        focus:outline-none z-20"
                    >
                      <div className="py-1">
                        {options.map((option) => (
                          <Menu.Item key={option.value}>
                            {({ active }) => (
                              <button
                                onClick={() => setSortBy(option.value)}
                                className={`w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition
                    ${active
                                    ? "bg-gray-100 text-gray-900 dark:bg-white/5 dark:text-white"
                                    : "text-gray-900 dark:text-white"
                                  }`}
                              >
                                {/* Radio Dot */}
                                <span
                                  className={`h-3 w-3 rounded-full border transition-all duration-200
                      ${sortBy === option.value
                                      ? "border-[#FF6600] bg-[#FF6600]"
                                      : "border-gray-400 dark:border-gray-500"
                                    }`}
                                />
                                <span>{option.label}</span>
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </div>
                    </Menu.Items>
                  </Menu>
                  <button
                    onClick={() => setShowAdCopy((prev) => !prev)}
                    className=" text-gray-500 dark:bg-[#232323] dark:border-gray-600  dark:text-[#fff] hover:text-gray-700 dark:hover:text-gray-300 bg-gray-100 dark:hover:bg-[#232323] px-4 py-5 h-3 text-xs z-10 rounded-md flex items-center gap-1 border border-transparent"
                    style={{ boxShadow: "0 1px 2px rgba(16,30,54,0.04)" }}
                  >
                    {showAdCopy ? (
                      <svg
                        className="w-3 h-3 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M17.94 17.94A10.06 10.06 0 0 1 12 20c-5.52 0-10-4.48-10-10 0-2.21.72-4.25 1.94-5.94M6.34 6.34A7.96 7.96 0 0 1 12 4c4.41 0 8 3.59 8 8 0 1.61-.48 3.11-1.3 4.36M1 1l22 22"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-3 h-3 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <ellipse
                          cx="12"
                          cy="12"
                          rx="10"
                          ry="6"
                          strokeWidth="2"
                        />
                        <circle cx="12" cy="12" r="3" strokeWidth="2" />
                      </svg>
                    )}
                    {showAdCopy ? "Hide" : "Show"} Copy
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="p-6">
            {activeTab === "my-content" && (
              <div className="space-y-6">
                {/* Content Type Filter */}
                <div className="flex items-center gap-4 overflow-x-auto pb-2">
                  {/* {contentTypes.map((type) => (
                    <button
                      key={type.id}
                      onClick={() => setSelectedContentFilter(type.id)}
                      className={`flex items-center gap-2 px-4 py-1 rounded-lg whitespace-nowrap transition-colors ${
                        selectedContentFilter === type.id
                          ? "bg-orange-100 dark:bg-orange-500/20 dark:border-orange-500/20 dark:hover:!bg-orange-500/20 text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800"
                          : "bg-gray-100 dark:bg-[#161616] text-gray-600 dark:text-gray-400 hover:bg-[#161616] dark:hover:bg-[#161616]"
                      }`}
                    >
                      {type?.notSvg ? (
                        <img src={type?.icon} className="w-4 h-4" />
                      ) : (
                        <span
                          dangerouslySetInnerHTML={{ __html: type?.icon }}
                          className="w-4 h-4"
                        />
                      )}
                      {type.name}
                      <span className="bg-white dark:bg-[#222222] px-2 py-0.5 rounded text-xs font-medium text-gray-700 dark:text-[#fff]">
                        {type.count}
                      </span>
                    </button>
                  ))} */}
                  {contentTypes.map((type) => (
                    <button
                      key={type.id}
                      onClick={() => setSelectedContentFilter(type.id)}
                      className={`flex items-center gap-2 px-4 py-1 rounded-lg whitespace-nowrap transition-colors ${selectedContentFilter === type.id
                        ? "bg-orange-100 dark:bg-orange-500/20 text-orange-700 dark:text-orange-300 border border-orange-200 dark:border-orange-800 hover:bg-orange-200 dark:hover:bg-orange-500/30"
                        : "bg-gray-100 dark:bg-[#161616] text-gray-600 dark:text-gray-400 border border-transparent hover:bg-gray-200 dark:hover:bg-[#1f1f1f]"
                        }`}
                    >
                      {type?.notSvg ? (
                        <img alt="" src={type?.icon} className="w-4 h-4" />
                      ) : (
                        <span
                          dangerouslySetInnerHTML={{ __html: type?.icon }}
                          className="w-4 h-4"
                        />
                      )}
                      {type.name}
                      {/* <span className="bg-white dark:bg-[#222222] px-2 py-0.5 rounded text-xs font-medium text-gray-700 dark:text-[#fff]">
                        {type.count}
                      </span> */}
                    </button>
                  ))}
                </div>

                {/* Content Grid */}

                <div>
                  {/* Video Content */}
                  {selectedContentFilter === "video" &&
                    (loading || visibleAds.length > 0 || inProcessAds > 0) &&
                    renderVideoGrid(visibleAds)}

                  {/* Image Ads Content */}
                  {(selectedContentFilter === "ads" ||
                    selectedContentFilter === "automation") &&
                    (loading || visibleAds.length > 0 || inProcessAds > 0) &&
                    renderAdGrid(visibleAds)}

                  {/* AI CMO Content */}
                  {!loading && selectedContentFilter === "aicmo" &&
                    (visibleAds.length > 0 || inProcessAds > 0) &&
                    renderMixedGrid(visibleAds, true)}

                  {normalizedContentSearch && adsList.length > 0 && visibleAds.length === 0 && !loading && (
                    <div className="rounded-xl border border-gray-200 bg-gray-50 px-4 py-10 text-center text-sm text-gray-600 dark:border-white/10 dark:bg-white/5 dark:text-gray-300">
                      No content matches “{contentSearch.trim()}”.
                    </div>
                  )}

                  {/* In-process skeletons are handled within each renderVideoGrid/renderAdGrid/renderMixedGrid function */}
                  {!adsList?.length && !loading && inProcessAds === 0 && (
                    <div className="text-center py-12">
                      <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center mx-auto mb-4">
                        <svg
                          className="w-8 h-8 text-gray-400 dark:text-gray-500"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                      </div>
                      <h3 className="text-md font-medium text-gray-900 dark:text-[#fff] mb-2">
                        {
                          contentTypes.find(
                            (t) => t?.id === selectedContentFilter
                          )?.name
                        }{" "}
                        Content
                      </h3>
                      <p className="text-gray-600 dark:text-gray-400 mb-4">
                        {selectedContentFilter === "stacked-ads"
                          ? "Multiple ad variations using 7-10 proven frameworks"
                          : selectedContentFilter === "emails"
                            ? "Email campaigns and newsletters"
                            : selectedContentFilter === "social"
                              ? "Posts, stories, and social content"
                              : selectedContentFilter === "landing"
                                ? "Website copy and landing page content"
                                : selectedContentFilter === "blog"
                                  ? "Articles, blog posts, and long-form content"
                                  : selectedContentFilter === "video"
                                    ? "Ad videos, UGC clips, and short-form videos — built to match your brand"
                                    : selectedContentFilter === "automation"
                                      ? "Ads, posts, and videos — automatically created on your schedule, delivered to your inbox, and saved here for easy access"
                                      : selectedContentFilter === "aicmo"
                                        ? "AI CMO generated videos and talking head advertisements"
                                        : "Social media advertisements and promotional content"}
                      </p>

                      {/* Action Buttons */}
                      {selectedContentFilter === "automation" && (
                        <button
                          onClick={() => setShowCreateModal(true)}
                          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
                        >
                          Create{" "}
                          {
                            contentTypes.find(
                              (t) => t?.id === selectedContentFilter
                            )?.name
                          }
                        </button>
                      )}

                      {selectedContentFilter !== "automation" ? (
                        <button
                          onClick={() =>
                            handleGenerateClick(selectedContentFilter)
                          }
                          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
                        >
                          Generate{" "}
                          {
                            contentTypes.find(
                              (t) => t?.id === selectedContentFilter
                            )?.name
                          }
                        </button>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            )}
            {activeTab === "brand-info" && selectedBrand && renderBrandInfo()}
          </div>
          <Transition appear show={isOpensDelete} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-[100]"
              onClose={closeModalDelete}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white  p-6 text-left align-middle shadow-xl transition-all text-center">
                      <Dialog.Title
                        as="h3"
                        className="text-md font-medium leading-6 text-black"
                      >
                        Delete
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Are you sure? This will delete the original and all
                          its variations
                        </p>
                      </div>

                      <div className="mt-4">
                        <button
                          style={{
                            background: "#FF6600",
                            width: "80px",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "50px",
                          }}
                          type="button"
                          className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                          onClick={handleDeleteSelected}
                          disabled={isDeleting}
                        >
                          {isDeleting ? (
                            <CircularLoader size={20} color="white" />
                          ) : (
                            "Yes"
                          )}
                        </button>
                        <button
                          style={{
                            background: "#000",
                            width: "80px",
                            color: "#fff",
                            padding: "10px",
                            borderRadius: "50px",
                          }}
                          type="button"
                          className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                          onClick={closeModalDelete}
                        >
                          No
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
          <ScrollToTop smooth color="#fff" component={<MySVG />} />
          <ToastContainer />
          {/* Generate Content Modal */}

          <CreateCampaignModal
            open={showCreateModal}
            onOpenChange={setShowCreateModal}
            onCampaignCreated={() => { }}
            prefilledData={false}
            selectedBrandValue={selectedBrandId}
          />


          <CreateVideoModal
            open={showGenerateModal}
            onOpenChange={setShowGenerateModal}
            selectedBrandId={selectedBrandId}
            setInProcessAdWithReference={setInProcessAdWithReference}
            setSelectedBrandName={setSelectedBrandName}
            setSelectedBrandId={setSelectedBrandId}
            selectedBrandName={selectedBrandName}
            referenceCard={referenceCard}
            referenceCardId={referenceCardId}
            onContentGenerated={handleContentGenerated}
            preselectedContentType={selectedContentFilter}
            onHandleBrandSelect={handleBrandSelect}
          />
        </div>
      )}
    </>
  );
};

export default AdsList;
